<template>
  <div class="alarm-records">
    <div class="record-header">
      <div class="header-item">触发时间</div>
      <div class="header-item">事件名称</div>
      <div class="header-item" style="flex: 2">项目地址</div>
    </div>
    <div class="record-table">
      <div
        class="record-row"
        v-for="(record, index) in records"
        :key="index"
        @click="showAlarmDetail(record, records)"
        style="cursor: pointer"
      >
        <div class="record-time">{{ record.createtime }}</div>
        <div class="record-type">{{ record.event_name }}</div>
        <div class="record-location">{{ record.community_name }}</div>
      </div>
    </div>

    <!-- 报警详情弹窗 -->
    <div v-if="showModal" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>报警详情 ({{ currentRecordIndex + 1 }} / {{ allRecords.length }})</h3>
          <button class="close-btn" @click="closeModal">&times;</button>
        </div>
        <div class="modal-body">
          <!-- 有图片时显示图片轮播 -->
          <div v-if="getCurrentRecordImages().length > 0">
            <!-- 图片轮播 -->
            <div class="image-carousel-section">
              <!-- 悬浮事件名称提示 -->
              <div class="event-name-tooltip">
                {{ getCurrentRecordEventName() }}
              </div>

              <div class="carousel-container">
                <button
                  class="carousel-btn prev"
                  @click="prevImageInRecord"
                  :disabled="currentRecordIndex === 0 && currentImageIndex === 0"
                >
                  ‹
                </button>
                <div class="carousel-image-wrapper">
                  <div class="image-container">
                    <img
                      v-if="getCurrentRecordImage() && !imageErrors.has(getCurrentRecordImage())"
                      :src="getCurrentRecordImage()"
                      alt="报警图片"
                      class="carousel-image"
                      @error="handleImageError"
                    />
                    <div v-else class="image-error-placeholder">
                      <div class="error-icon">⚠️</div>
                      <div class="error-text">图片加载失败</div>
                    </div>
                  </div>
                  <div class="image-counter">
                    {{ currentRecordIndex + 1 }} / {{ allRecords.length }}
                    <span v-if="getCurrentRecordImages().length > 1" style="font-size: 12px; color: #00d4ff;">
                      ({{ currentImageIndex + 1 }}/{{ getCurrentRecordImages().length }})
                    </span>
                  </div>
                </div>
                <button
                  class="carousel-btn next"
                  @click="nextImageInRecord"
                  :disabled="currentRecordIndex === allRecords.length - 1 && currentImageIndex === getCurrentRecordImages().length - 1"
                >
                  ›
                </button>
              </div>
              <div class="carousel-indicators">
                <span
                  v-for="(_record, index) in allRecords"
                  :key="index"
                  class="indicator"
                  :class="{ active: index === currentRecordIndex }"
                  @click="currentRecordIndex = index"
                ></span>
              </div>
            </div>
          </div>

          <!-- 无图片时的提示 -->
          <div v-else class="no-image-tip">
            <div>当前记录暂无相关图片</div>
            <div style="margin-top: 10px; font-size: 14px">
              共有 {{ allRecords.length }} 条报警记录，正在浏览第
              {{ currentRecordIndex + 1 }} 条
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlarmRecords",
  props: {
    records: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      showModal: false,
      allRecords: [], // 存储所有报警记录
      currentRecordIndex: 0, // 当前显示的记录索引
      currentImageIndex: 0, // 当前显示的图片索引
      imageErrors: new Set(), // 存储加载失败的图片URL
    };
  },
  methods: {
    showAlarmDetail(record, allRecords) {
      console.log("Clicked record:", record);
      console.log("All records:", allRecords);

      // 保存所有记录
      this.allRecords = allRecords || [];

      // 找到当前点击的记录在所有记录中的位置
      const clickedIndex = this.allRecords.findIndex((r) => r === record);
      this.currentRecordIndex = clickedIndex >= 0 ? clickedIndex : 0;
      this.currentImageIndex = 0;

      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.allRecords = [];
      this.currentRecordIndex = 0;
      this.currentImageIndex = 0;
    },
    // 获取当前记录的所有图片
    getCurrentRecordImages() {
      if (this.allRecords.length === 0) return [];
      const currentRecord = this.allRecords[this.currentRecordIndex];
      if (!currentRecord || !currentRecord.picture_file) return [];
      // 确保返回数组格式
      return Array.isArray(currentRecord.picture_file) ? 
        currentRecord.picture_file : 
        [currentRecord.picture_file];
    },
    // 获取当前显示的图片URL
    getCurrentRecordImage() {
      const images = this.getCurrentRecordImages();
      if (images.length === 0) return null;
      // 根据currentImageIndex选择当前图片
      return images.length > this.currentImageIndex ? images[this.currentImageIndex] : null;
    },
    // 切换到下一张图片（同一记录内的多张图片）
    nextImageInRecord() {
      const images = this.getCurrentRecordImages();
      if (this.currentImageIndex < images.length - 1) {
        this.currentImageIndex++;
      } else {
        // 已经是最后一张，切换到下一条记录的第一张
        this.nextRecord();
      }
    },
    // 切换到上一张图片（同一记录内的多张图片）
    prevImageInRecord() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--;
      } else {
        // 已经是第一张，切换到上一条记录的最后一张
        this.prevRecord();
      }
    },
    // 切换到下一条记录
    nextRecord() {
      if (this.currentRecordIndex < this.allRecords.length - 1) {
        this.currentRecordIndex++;
        this.currentImageIndex = 0;
      }
    },
    // 切换到上一条记录
    prevRecord() {
      if (this.currentRecordIndex > 0) {
        this.currentRecordIndex--;
        // 切换到上一条记录的最后一张图片
        const prevImages = this.getCurrentRecordImages();
        this.currentImageIndex = prevImages.length > 0 ? prevImages.length - 1 : 0;
      }
    },
    // 对外暴露的nextImage方法（保持向后兼容）
    nextImage() {
      this.nextRecord();
    },
    // 对外暴露的prevImage方法（保持向后兼容）
    prevImage() {
      this.prevRecord();
    },
    // 获取当前记录的事件名称
    getCurrentRecordEventName() {
      if (this.allRecords.length === 0) return "";
      const currentRecord = this.allRecords[this.currentRecordIndex];
      return currentRecord
        ? currentRecord.event_name || this.getEventNameByCode(currentRecord.event)
        : "";
    },
    nextImage() {
      if (this.currentRecordIndex < this.allRecords.length - 1) {
        this.currentRecordIndex++;
        this.currentImageIndex = 0;
      }
    },
    prevImage() {
      if (this.currentRecordIndex > 0) {
        this.currentRecordIndex--;
        this.currentImageIndex = 0;
      }
    },
    handleImageError(event) {
      // 设置错误状态，通过数据驱动显示错误提示
      if (!this.imageErrors) {
        this.imageErrors = new Set();
      }
      const imgSrc = event.target.src;
      this.imageErrors.add(imgSrc);
    },

    getEventNameByCode(eventCode) {
      // 根据事件代码返回对应的事件名称
      const eventMap = {
        16: "长时间开门事件",
        // 可以添加更多事件代码映射
      };
      return eventMap[eventCode] || `未知事件(${eventCode})`;
    },
  },
};
</script>

<style scoped lang="less">
.alarm-records {
  flex: 1;
  background: rgba(10, 25, 41, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.2);
  position: relative;
}

/* 弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(5px);
}

.modal-content {
  background: linear-gradient(135deg, rgba(10, 25, 41, 0.95), rgba(0, 40, 80, 0.95));
  border: 2px solid rgba(0, 212, 255, 0.5);
  border-radius: 15px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 0 30px rgba(0, 212, 255, 0.3);
  animation: modalFadeIn 0.3s ease-out;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.8) translateY(-50px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  border-bottom: 2px solid rgba(0, 212, 255, 0.3);
}

.modal-header h3 {
  color: #00d4ff;
  margin: 0;
  font-size: 20px;
  font-weight: bold;
}

.close-btn {
  background: none;
  border: none;
  color: #00d4ff;
  font-size: 28px;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s;
}

.close-btn:hover {
  background: rgba(0, 212, 255, 0.2);
  transform: rotate(90deg);
}

.modal-body {
  padding: 25px;
  position: relative;
}

/* 事件名称悬浮提示 */
.event-name-tooltip {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  color: #00d4ff;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: bold;
  z-index: 10;
  background: transparent;
  box-shadow: none;
  backdrop-filter: none;
  animation: tooltipFadeIn 0.3s ease-out;
}

@keyframes tooltipFadeIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* 无图片提示 */
.no-image-tip {
  text-align: center;
  color: #888;
  font-size: 16px;
  padding: 60px 20px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  border: 2px dashed rgba(255, 255, 255, 0.1);
}

/* 图片容器 */
.image-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 图片错误占位符 */
.image-error-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgba(255, 107, 107, 0.1);
  border: 2px dashed rgba(255, 107, 107, 0.3);
  border-radius: 8px;
  color: #ff6b6b;
}

.error-icon {
  font-size: 48px;
  margin-bottom: 10px;
}

.error-text {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}

/* 记录简要信息 */
.record-brief-info {
  margin-top: 20px;
  padding: 15px;
  background: rgba(0, 212, 255, 0.1);
  border-radius: 8px;
  border: 1px solid rgba(0, 212, 255, 0.3);
}

.brief-item {
  display: flex;
  margin-bottom: 8px;
  align-items: center;
}

.brief-item:last-child {
  margin-bottom: 0;
}

.brief-label {
  color: #00d4ff;
  font-weight: bold;
  min-width: 50px;
  margin-right: 10px;
  font-size: 14px;
}

.brief-value {
  color: #ffffff;
  flex: 1;
  font-size: 14px;
  word-break: break-all;
}

.detail-info {
  margin-bottom: 25px;
}

.info-row {
  display: flex;
  margin-bottom: 12px;
  align-items: flex-start;
}

.info-row .label {
  color: #00d4ff;
  font-weight: bold;
  min-width: 100px;
  margin-right: 10px;
}

.info-row .value {
  color: #ffffff;
  flex: 1;
  word-break: break-word;
}

.record-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 2px solid rgba(0, 212, 255, 0.5);
  margin-bottom: 10px;
  .header-item {
    font-weight: bold;
    color: #00d4ff;
    flex: 1;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.record-table {
  height: 270px;
  overflow-y: auto;
}

.record-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: background-color 0.3s;
  .record-time,
  .record-type,
  .record-location {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
}

.record-row:hover {
  background-color: rgba(0, 212, 255, 0.1);
}

.record-time {
  color: #00d4ff;
  font-size: 12px;
  flex: 1;
}

.record-type {
  color: #ffaa00;
  font-size: 12px;
  flex: 1;
}

.record-location {
  color: #ffffff;
  font-size: 12px;
  flex: 2;
}

// 滚动条样式
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 212, 255, 0.5);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 212, 255, 0.8);
}
/* 轮播图样式 */
.image-carousel-section {
  margin-top: 20px;
}

.image-carousel-section h4 {
  color: #00d4ff;
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: bold;
}

.carousel-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 20px;
}

.carousel-image-wrapper {
  position: relative;
  width: 600px;
  height: 400px;
  max-width: 100%;
  margin: 0 30px;
}

.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
  border: 2px solid rgba(0, 212, 255, 0.3);
  box-shadow: 0 0 15px rgba(0, 212, 255, 0.2);
}

.image-counter {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: #00d4ff;
  padding: 5px 10px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: bold;
}

.carousel-btn {
  background: rgba(0, 212, 255, 0.2);
  border: 2px solid rgba(0, 212, 255, 0.5);
  color: #00d4ff;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 20px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.carousel-btn:hover:not(:disabled) {
  background: rgba(0, 212, 255, 0.4);
  border-color: #00d4ff;
  transform: scale(1.1);
}

.carousel-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.carousel-indicators {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 15px;
}

.indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(0, 212, 255, 0.3);
  cursor: pointer;
  transition: all 0.3s;
}

.indicator.active {
  background: #00d4ff;
  transform: scale(1.2);
}

.indicator:hover {
  background: rgba(0, 212, 255, 0.6);
}

/* 弹窗内容滚动条 */
.modal-content::-webkit-scrollbar {
  width: 8px;
}

.modal-content::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.modal-content::-webkit-scrollbar-thumb {
  background: rgba(0, 212, 255, 0.4);
  border-radius: 4px;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 212, 255, 0.7);
}
</style>
